import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import { deg2Sgn2 } from "./util";
import { nanoid } from "nanoid";
import { CTX } from "../components/Store";
import "./TLEdit.css";
import "react-tabs/style/react-tabs.css";
import data from "./tl-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";

export default function Rectify() {
  const { st, sendReq } = useContext(CTX);

  const [contacts, setContacts] = useState(data);
  const [lookupName, setLookupName] = useState("");
  const [defval, setDefval] = useState("");
  const [ptype, setPtype] = useState("");
  const [events, setEvents] = useState([]);

  const [addFormData, setAddFormData] = useState({ fullName: "", address: "" });
  const [editEventData, setEditEventData] = useState({ fullName: "", address: "" });
  const [editEventId, setEditEventId] = useState(null);

  const messageRef = useRef("");
  const forceUpdate = useCallback(() => setEvents((x) => [...x]), []);

  useEffect(() => {
    if (st.name) setLookupName(st.name);

    if (st.id) {
      const req = `"{"event":"ipevts-req","data":"{'id': ${st.id}, 'from':'0000-01-01', 'to':'0000-01-02', 'days':0, 'ptype':'${st.ptype || "tr"}', 'pidx':${st.pidx}, 'tl_sel':'${st.tl_sel}'}"}"`;
      sendReq({ msg: req });
    }

    if (st.tlines?.length > 0) {
      const dup = st.tlines.includes("dup");
      messageRef.current = dup ? "Period already exists" : "";
      setDefval("");
    }

    forceUpdate();
  }, [st.lng, st.tlines]);

  useEffect(() => {
    setEvents(st.pevts);
    if (Array.isArray(st.pevts)) {
      st.pevts.forEach((e) => {
        e.pred_lng = deg2Sgn2(e.pred_lng);
      });
    }
  }, [st.pevts]);

  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    setAddFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditEventData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidDate = (d) => !isNaN(new Date(d).getTime());

  const handleAddFormSubmit = (evt) => {
    evt.preventDefault();

    if (!lookupName) {
      messageRef.current = "Missing Chart Name!!";
      forceUpdate();
      return;
    }

    if (!st.tl_sel) {
      messageRef.current = "Missing Period Name!!";
      forceUpdate();
      return;
    }

    if (!isValidDate(addFormData.fullName)) {
      messageRef.current = "Invalid Date!!";
      forceUpdate();
      return;
    }

    const desc = addFormData.address.replace(/['"]/g, "");

    const newContact = {
      id: nanoid(),
      d: addFormData.fullName,
      e: desc,
    };

    setContacts((prev) => [...prev, newContact]);

    const req = `"{"event":"tl_updt","data":"{'id': ${st.id}, 'dt':'${addFormData.fullName}', 'title':'${desc}','period':'${st.tl_sel}','tl_id': 0,'action':'add' }"}"`;
    sendReq({ msg: req });

    setAddFormData({ fullName: "", address: "" });
  };

  const onSearchName = (e) => {
    const val = e.target.value;
    setLookupName(val);

    if (val) {
      const lsReg = localStorage.getItem("sgaRegister");
      const req = `"{"event":"lookup-rectify","data":"{'srch': '${val}','auth': '${lsReg}','updt': true}"}"`;
      sendReq({ msg: req });
    } else {
      st.lookups = [];
    }
  };

  const onLookup = (lookup) => {
    if (lookup.name) {
      const req = `"{"event":"chart-req","data":"{'id': ${lookup.id}}"}"`;
      sendReq({ msg: req });
    }
    setLookupName(lookup.name);
    st.lookups = [];
  };

  const predictionChg = (e) => {
    st.ptype = e.target.value || "sa";
    setPtype(st.ptype);

    const req = `"{"event":"rectify-req","data":"{'fid': ${st.id}, 'ptype': '${st.ptype}'}"}"`;
    sendReq({ msg: req });
  };

  return (
    <>
      <h2 style={{ textAlign: "center" }}>Rectify Chart</h2>

      <div className="clihdr">
        <div className="lu01b">
          <input
            className="inp01"
            type="text"
            value={lookupName}
            onChange={onSearchName}
            autoComplete="off"
            placeholder="Chart name..."
          />

          <select value={defval} onChange={predictionChg}>
            <option value="" disabled>Prediction Type</option>
            <option value="sa">Solar Arc</option>
            <option value="tr">Transits</option>
            <option value="pr">Progressions</option>
          </select>
        </div>
      </div>

      {/* Lookup Results */}
      <div className="lu02" id="lookups">
        <ul className="dd01">
          {st.lookups?.map((lookup, i) => (
            <li onClick={() => onLookup(lookup)} key={i}>
              {lookup.name}
            </li>
          ))}
        </ul>
      </div>

      {/* Events Table */}
      <div className="app-container">
        <table>
          <thead>
            <tr>
              <th width="400">Event</th>
              <th width="60">Date</th>
              <th width="60">PL</th>
              <th width="50">SArcPL</th>
              <th width="150">SADate</th>
            </tr>
          </thead>
          <tbody>
            {st.pevts?.map((item, i) => (
              <tr key={i}>
                <td>{item.event}</td>
                <td>{item.dt}</td>
                <td>{item.pred_type}</td>
                <td>{item.pred_lng}</td>
                <td>{item.rdt}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="col text-center">
          <span className="emsg">{messageRef.current}</span>
        </div>
      </div>
    </>
  );
}

